(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["md-mix-match-credit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-mix-match')) {
    class MedjoolMixMatch extends HTMLElement {
      static subtotal(lines, variants) {
        return [...lines].reduce((sum, [id, quantity]) => {
          const variant = variants.get(String(id));
          return variant && variant.available && Number.isInteger(quantity) && quantity > 0 ? sum + variant.price * quantity : sum;
        }, 0);
      }
      static reward(total, threshold) {
        return { remaining: Math.max(0, threshold - total), progress: Math.min(threshold, Math.max(0, total)), unlocked: total >= threshold };
      }
      static items(lines, variants, batch) {
        return [...lines].map(([id, quantity]) => {
          const variant = variants.get(String(id));
          if (!variant || !variant.available || !Number.isInteger(quantity) || quantity < 1 || quantity > variant.max) throw new Error('Invalid selection');
          return { id: variant.id, quantity, properties: { _md_offer: 'next_box_credit', _md_mix: batch } };
        });
      }
      connectedCallback() {
        if (this.initialized) {
          this.summaryObserver?.observe(this.querySelector('.mdm-summary'));
          return;
        }
        this.initialized = true;
        try {
          this.config = JSON.parse(this.querySelector('[data-mix-config]').textContent);
          this.strings = this.config.strings;
          this.variants = new Map(this.config.variants.map(variant => [String(variant.id), variant]));
          this.lines = new Map();
          this.currency = this.dataset.currency;
          this.supported = this.currency === 'USD';
          this.root = window.Shopify?.routes?.root || '/';
          this.format = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.currency });
          this.querySelector('[data-currency-notice]').hidden = this.supported;
          this.addEventListener('change', event => this.selectVariant(event));
          this.addEventListener('click', event => this.handleClick(event));
          this.render();
          if ('IntersectionObserver' in window) {
            this.summaryObserver = new IntersectionObserver(entries => {
              this.querySelector('.mdm-mobile-meter').hidden = entries[0].isIntersecting;
            }, { rootMargin: '0px 0px -80px 0px' });
            this.summaryObserver.observe(this.querySelector('.mdm-summary'));
          }
        } catch {
          this.querySelector('[data-currency-notice]').hidden = false;
        }
      }
      disconnectedCallback() { this.summaryObserver?.disconnect(); }
      money(amount) { return this.format.format(amount / 100); }
      variantFor(card) { return this.variants.get(card.querySelector('input:checked')?.value); }
      status(message) { this.querySelector('[data-status]').textContent = message; }
      selectVariant(event) {
        const card = event.target.closest('[data-product]');
        if (!card) return;
        const variant = this.variantFor(card);
        if (!variant) return;
        const image = card.querySelector('.mdm-product-image');
        image.removeAttribute('srcset');
        image.src = variant.image;
        image.alt = `${variant.name} — ${variant.size}`;
        card.querySelector('[data-card-price]').textContent = this.money(variant.price);
        this.renderControls();
      }
      handleClick(event) {
        const add = event.target.closest('[data-add]');
        const delta = event.target.closest('[data-delta]');
        const checkout = event.target.closest('[data-checkout]');
        if (add) {
          const variant = this.variantFor(add.closest('[data-product]'));
          if (variant) this.change(String(variant.id), 1);
        } else if (delta) {
          this.change(delta.closest('[data-variant]').dataset.variant, Number(delta.dataset.delta));
        } else if (checkout) {
          this.submit();
        }
      }
      change(id, delta) {
        if (!this.supported || this.busy || this.locked) return;
        const variant = this.variants.get(id);
        if (!variant?.available) return;
        const next = (this.lines.get(id) || 0) + delta;
        if (next > variant.max) { this.status(this.strings.limit); return; }
        if (next <= 0) this.lines.delete(id); else this.lines.set(id, next);
        this.status(delta > 0 ? this.strings.added.replace('__item__', `${variant.size} ${variant.name}`) : '');
        this.render();
      }
      renderControls() {
        this.querySelectorAll('[data-product]').forEach(card => {
          const variant = this.variantFor(card);
          card.querySelector('[data-add]').disabled = !this.supported || this.busy || this.locked || !variant?.available || (this.lines.get(String(variant.id)) || 0) >= variant.max;
          card.querySelectorAll('input').forEach(input => { input.disabled = Boolean(this.busy || this.locked || !this.variants.get(input.value)?.available); });
        });
        this.querySelectorAll('[data-delta]').forEach(button => {
          const id = button.closest('[data-variant]').dataset.variant;
          button.disabled = Boolean(this.busy || this.locked || (Number(button.dataset.delta) > 0 && this.lines.get(id) >= this.variants.get(id).max));
        });
        const checkout = this.querySelector('[data-checkout]');
        checkout.disabled = !this.supported || this.lines.size === 0 || this.busy || this.locked;
        checkout.textContent = this.busy ? this.strings.busy : this.strings.cta;
      }
      render() {
        const container = this.querySelector('[data-lines]');
        const active = document.activeElement;
        const focusedId = active?.closest('[data-variant]')?.dataset.variant;
        const focusedDelta = active?.dataset.delta;
        container.replaceChildren();
        this.lines.forEach((quantity, id) => {
          const variant = this.variants.get(id);
          const row = this.querySelector('[data-line-template]').content.firstElementChild.cloneNode(true);
          row.dataset.variant = id;
          row.querySelector('img').src = variant.image;
          row.querySelector('[data-line-name]').textContent = variant.name;
          row.querySelector('[data-line-size]').textContent = variant.size;
          row.querySelector('[data-line-price]').textContent = this.money(variant.price * quantity);
          row.querySelector('[data-line-quantity]').textContent = quantity;
          row.querySelectorAll('[data-delta]').forEach(button => button.setAttribute('aria-label', (Number(button.dataset.delta) > 0 ? this.strings.increase : this.strings.decrease).replace('__item__', `${variant.size} ${variant.name}`)));
          container.append(row);
        });
        if (focusedId && focusedDelta) {
          const target = [...container.querySelectorAll('[data-variant]')].find(row => row.dataset.variant === focusedId)?.querySelector(`[data-delta="${focusedDelta}"]`);
          (target || this.querySelector('[data-add]'))?.focus({ preventScroll: true });
        }
        const total = MedjoolMixMatch.subtotal(this.lines, this.variants);
        const reward = MedjoolMixMatch.reward(total, this.config.threshold);
        const progressText = !this.supported ? this.strings.currency : reward.unlocked ? this.strings.unlocked : total === 0 ? this.strings.start : this.strings.remaining.replace('__amount__', this.money(reward.remaining));
        this.querySelector('[data-empty]').hidden = this.lines.size > 0;
        this.querySelector('[data-count]').textContent = [...this.lines.values()].reduce((sum, quantity) => sum + quantity, 0);
        this.querySelector('[data-subtotal]').textContent = this.money(total);
        this.querySelector('[data-mobile-total]').textContent = this.money(total);
        this.querySelector('[data-mobile-text]').textContent = progressText;
        this.querySelector('[data-progress-text]').textContent = progressText;
        this.querySelector('[data-progress-amount]').textContent = this.money(total);
        this.querySelector('[data-progress]').value = reward.progress;
        const panel = this.querySelector('[data-reward]');
        panel.classList.toggle('is-unlocked', reward.unlocked && this.supported);
        if (reward.unlocked && !this.wasUnlocked && this.supported) {
          panel.classList.remove('is-celebrating');
          void panel.offsetWidth;
          panel.classList.add('is-celebrating');
          setTimeout(() => panel.classList.remove('is-celebrating'), 1000);
        }
        this.wasUnlocked = reward.unlocked;
        this.renderControls();
      }
      async submit() {
        if (!this.supported || this.busy || this.locked || !this.lines.size) return;
        this.busy = true;
        this.renderControls();
        this.status('');
        let attempted = false;
        try {
          const beforeResponse = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!beforeResponse.ok) throw new Error('Cart unavailable');
          const before = await beforeResponse.json();
          if (before.currency !== 'USD') {
            this.supported = false;
            this.querySelector('[data-currency-notice]').hidden = false;
            this.status(this.strings.currency);
            return;
          }
          const batch = crypto.randomUUID();
          const items = MedjoolMixMatch.items(this.lines, this.variants, batch);
          attempted = true;
          const response = await fetch(`${this.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!response.ok) throw new Error('Cart addition not confirmed');
          const result = await response.json();
          if (!Array.isArray(result.items) || result.items.length !== items.length) throw new Error('Cart addition incomplete');
          this.locked = true;
          this.lines.clear();
          this.render();
          this.status(this.strings.success);
          this.querySelector('[data-cart-link]').hidden = false;
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.locked = attempted;
          this.status(attempted ? this.strings.uncertain : this.strings.error);
          this.querySelector('[data-cart-link]').hidden = !attempted;
        } finally {
          this.busy = false;
          this.renderControls();
        }
      }
    }
    customElements.define('md-mix-match', MedjoolMixMatch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-rutab-subscription"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialize(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const data=JSON.parse(root.querySelector('[data-sub-data]').textContent),form=root.querySelector('form'),button=form.querySelector('[type="submit"]'),error=form.querySelector('[role="alert"]');
    let variant=data.variants[0],plan=variant?.plans.find(p=>String(p.id)===String(variant.planId||data.planId));
    const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency}).format(value/100);
    let busy=false;
    const copyNodes=[...document.querySelectorAll('[data-box-copy]')].map(node=>({node,text:node.textContent}));
    const sizeInputs=[...root.querySelectorAll('[name="box_upgrade"]')];
    function selectBox(id){
      variant=data.variants.find(item=>String(item.id)===String(id))||data.variants[0];
      plan=variant?.plans.find(item=>String(item.id)===String(variant.planId||data.planId));
      form.querySelector('[name="id"]').value=variant.id;
      form.querySelector('[name="selling_plan"]').value=plan?.id||'';
      const upgraded=variant.id!==data.variants[0].id;
      copyNodes.forEach(({node,text})=>{node.textContent=upgraded?text.replaceAll('3 lb','5 lb').replaceAll('30 days','60 days').replaceAll('30 Days','60 Days').replaceAll('30-day','60-day'):text;});
      const boxImage=document.querySelector('.md-story__routine-image img'),boxUrl=data.boxImages?.[variant.title];
      if(boxImage&&boxUrl){boxImage.removeAttribute('srcset');boxImage.src=boxUrl;boxImage.alt=variant.title;}
      error.hidden=true;update();
    }
    sizeInputs.forEach(input=>input.addEventListener('change',()=>selectBox(input.value)));
    function update(){
      sizeInputs.forEach(input=>{const item=data.variants.find(v=>String(v.id)===input.value);input.disabled=busy||!item?.available||!item.plans.some(p=>String(p.id)===String(item.planId||data.planId));});
      button.disabled=busy||!variant?.available||!plan;
      button.textContent=busy?data.text.loading:!variant?.available||!plan?data.text.unavailable:data.text.cta;
      if(!variant||!plan)return;
      const first=plan.adjustments[0]?.price??plan.price,repeat=plan.adjustments.at(-1)?.price??plan.price;

      root.querySelector('[data-hero-price]').textContent=money(first);
      root.querySelector('[data-regular-price]').textContent=money(variant.price);

    }
    root.querySelector('[data-details-link]').addEventListener('click',()=>{root.querySelector('#rutab-product-details').open=true});
    root.querySelectorAll('[data-image]').forEach(thumb=>thumb.addEventListener('click',()=>{const image=root.querySelector('.md-sub__image');image.removeAttribute('srcset');image.src=thumb.dataset.image;image.alt=thumb.dataset.alt;root.querySelectorAll('[data-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===thumb)))}));
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(busy||!variant?.available||!plan)return;busy=true;error.hidden=true;update();
      try{
        const properties={_offer:data.offerKey,_offer_version:data.offerVersion,_experiment_arm:'subscription-offer',_purchase_mode:'subscription',_baseline_product_id:'5786922352792'};
        if(sizeInputs.length){properties._selected_box=variant.title;properties._box_upgrade=variant.id===data.variants[0].id?'none':'5lb';}
        const response=await fetch(data.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1,selling_plan:plan.id,properties}]})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||data.text.error);window.location.assign(data.cartUrl);
      }catch(e){error.textContent=e.message||data.text.error;error.hidden=false;busy=false;update()}
    });
    if(sizeInputs.length){sizeInputs[0].checked=true;selectBox(data.variants[0].id);}else{update();}
  }
  document.querySelectorAll('[data-md-sub]').forEach(initialize);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-md-sub]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_bundle_ny"] && !Shopify.designMode) return;
  try {
    
(function () {
  const BTN_SELECTOR = '.bundle-upsell__button--primary';
  const MODAL_ID = 'BundleSoldOutModal';
  let lock = false;

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }

  function getSoldOutTitlesFromBtn(btn) {
    const sold = [];
    const p1Avail = (btn.dataset.product1Available || '').toString() === 'true';
    const p2Avail = (btn.dataset.product2Available || '').toString() === 'true';

    if (!p1Avail && btn.dataset.product1Title) sold.push(btn.dataset.product1Title);
    if (!p2Avail && btn.dataset.product2Title) sold.push(btn.dataset.product2Title);

    return sold;
  }

  function openSoldOutModal(titles) {
    const modal = qs('#' + MODAL_ID);
    if (!modal) return;

    const list = qs('#BundleSoldOutList', modal);
    const titleEl = qs('#BundleSoldOutTitle', modal);
    const descEl = qs('#BundleSoldOutDesc', modal);
    const closeBtn = qs('[data-bundle-modal-close]', modal);

    list.innerHTML = '';
    (titles || []).forEach((t) => {
      const li = document.createElement('li');
      li.textContent = t + ' is sold out';
      list.appendChild(li);
    });

    if (!titles || titles.length === 0) {
      titleEl.textContent = 'This bundle is currently unavailable';
      descEl.textContent = 'One or more items are sold out right now.';
      list.innerHTML = '';
    } else if (titles.length === 1) {
      titleEl.textContent = 'This bundle is currently unavailable';
      descEl.textContent = 'One item is out of stock:';
    } else {
      titleEl.textContent = 'This bundle is currently unavailable';
      descEl.textContent = 'These items are out of stock:';
    }

    modal.classList.remove('is-closing');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bundle-modal-lock');

    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeSoldOutModal() {
    const modal = qs('#' + MODAL_ID);
    if (!modal || !modal.classList.contains('is-open')) return;

    modal.classList.add('is-closing');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bundle-modal-lock');

    window.setTimeout(() => {
      modal.classList.remove('is-closing');
    }, 240);
  }

  document.addEventListener('click', (e) => {
    const modal = qs('#' + MODAL_ID);
    if (!modal) return;

    if (e.target.closest('[data-bundle-modal-close]')) {
      closeSoldOutModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSoldOutModal();
  });

  async function addToCart(variantIds, qtys = [1, 1]) {
    const body = new FormData();
    variantIds.forEach((id, i) => {
      body.append(`items[${i}][id]`, id);
      body.append(`items[${i}][quantity]`, qtys[i]);
    });

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body,
      headers: { Accept: 'application/json' }
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || data.description || 'Failed to add to cart');
    return data;
  }

  // Fetch the latest drawer HTML using sections endpoint (most reliable)
  async function refreshCartDrawerSection() {
    const res = await fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } });
    const json = await res.json();
    updateCartDrawer(json['cart-drawer']);
  }

  function updateCartDrawer(html) {
    if (!html) return;

    const temp = document.createElement('div');
    temp.innerHTML = html;

    // Prefer replacing the whole <cart-drawer> element if present
    const newDrawerEl = temp.querySelector('cart-drawer');
    const currentDrawerEl = document.querySelector('cart-drawer');

    if (newDrawerEl && currentDrawerEl) {
      currentDrawerEl.replaceWith(newDrawerEl);
      return;
    }

    // Fallback: update #CartDrawer if your theme uses it
    const newCartDrawer = temp.querySelector('#CartDrawer');
    const currentCartDrawer = document.querySelector('#CartDrawer');

    if (newCartDrawer && currentCartDrawer) {
      currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
    }
  }

  async function refreshCartBubble() {
    const res = await fetch('/?sections=header', { headers: { Accept: 'application/json' } });
    const json = await res.json();

    const temp = document.createElement('div');
    temp.innerHTML = json.header;

    const newBubble = temp.querySelector('#cart-icon-bubble');
    const oldBubble = document.querySelector('#cart-icon-bubble');

    if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
  }

  async function openDrawer() {
    await refreshCartBubble();

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(document.querySelector('#cart-icon-bubble'));
      return;
    }

    // Fallback: click header cart icon if open() isn't available
    const bubble = document.querySelector('#cart-icon-bubble a, #cart-icon-bubble');
    if (bubble) bubble.click();
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(BTN_SELECTOR);
    if (!btn || lock) return;

    const v1 = btn.dataset.variantId1;
    const v2 = btn.dataset.variantId2;
    if (!v1 || !v2) return;

    // sold-out check based on Liquid availability
    const soldOutTitles = getSoldOutTitlesFromBtn(btn);
    if (soldOutTitles.length) {
      openSoldOutModal(soldOutTitles);
      return;
    }

    lock = true;
    const original = btn.dataset.originalText || btn.textContent.trim();
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      await addToCart([v1, v2]);

      // Always refresh drawer content from sections endpoint
      await refreshCartDrawerSection();

      // Open drawer after DOM is updated
      await openDrawer();
    } catch (err) {
      const msg = (err && (err.message || '')).toLowerCase();

      if (msg.includes('sold out') || msg.includes('inventory') || msg.includes('unavailable')) {
        openSoldOutModal([btn.dataset.product1Title, btn.dataset.product2Title].filter(Boolean));
      } else {
        alert(err.message || 'Failed to add bundle');
      }
    } finally {
      btn.textContent = original;
      btn.disabled = false;
      lock = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
